<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">Add New Project</h1>
      <p>
        Within the projects page, the user has the option to add a new project. To do so, the user has to click the
        button with the <b>plus sign</b> that reads <b>"<i class="fas fa-plus" />  Add Project"</b> on top
        of the Projects table.
      </p>

      <div class="image-container">
        <img src="@/images/manual/projects-page-add-button.png" alt="Add Button" />
        <div class="img-caption">Figure 1. Add Project Button Location</div>
      </div>

      <p>
        Once the button is pressed, a small modal will appear, which will prompt the user to select a <b>name</b> for the
        new project. The selected name name must <b>not be the same</b> as any of the already-existing project names. If
        that is the case a small error message will be displayed below the project name input field.
      </p>

      <div class="image-container">
        <v-row>
          <v-col>
            <img src="@/images/manual/add-project-prompt.png" alt="Valid Prompt" />
          </v-col>
          <v-col>
            <img src="@/images/manual/add-project-invalid-prompt.png" alt="Invalid Prompt" />
          </v-col>
        </v-row>
        <div class="img-caption">Figure 2. A project name that doesn't already exist (left), and a duplicate project
        name (right).</div>
      </div>

      <p>
        After a valid project name is provided, the <b>"Confirm Add"</b> button must be pressed to create the new project. After
        that, the projects page will be refreshed; displaying the new project in the projects list.
      </p>

      <div class="image-container">
        <img src="@/images/manual/new-project-succeeded.png" alt="A successful project addition" />
        <div class="img-caption">Figure 3. A successful project creation.</div>
      </div>

    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>
